<ng-container  #viewContainer2 dynamicField  [config]="columnDef" [group]="form"  [arrayColumnsDef]="parameters" [isDynamicform]="false" class="full" [entityName]="entityname" [condition]="condition" [entityDesc]="entitydesc" (editEventEmmiter)="eventEdit($event)">
</ng-container>
